<template>
	<div class="zonasur">
		<v-container  
				class="overflow-y-auto"
		>
			<v-layout row>
                
				<v-flex md9 xs12 class="pt-5 pa-4">
                    <v-flex xs12>
                        <h2>Sub sedes - zona norte</h2>
                    </v-flex>
					<v-container>
                        <v-row dense>
                            <v-col
                            v-for="(item, i) in items"
                            :key="i"
                            cols="12"
                            md="6"
                            >
                                <v-skeleton-loader
                                    :loading="loading"
                                    transition="scale-transition"
                                    height="94"
                                    type="list-item-two-line"
                                >
                                    <v-card
                                        :color="item.color"
                                        dark
                                    >
                                        <div class="d-flex flex-no-wrap justify-space-between">
                                            <div>
                                                <v-card-title
                                                class="headline"
                                                v-text="item.title"
                                                ></v-card-title>

                                                <v-card-subtitle v-text="item.subtitle"></v-card-subtitle>
                                                <v-card-subtitle v-text="item.direccion" class="pt-0"></v-card-subtitle>
                                            </div>

                                            <v-hover>
                                                <template v-slot:default="{ hover }">
                                                    <a :href="item.location"
                                                        target="_blank" class="text-decoration-none">
                                                        <v-avatar
                                                            class="ma-3"
                                                            size="125"
                                                            tile
                                                        >
                                                            <v-icon size="125">mdi-map-marker-outline</v-icon>
                                                            <v-fade-transition>
                                                                <v-overlay
                                                                    v-if="hover"
                                                                    absolute
                                                                    color="#036358"
                                                                >
                                                                    <v-btn color="transparent">Ver mapa</v-btn>
                                                                </v-overlay>
                                                            </v-fade-transition>
                                                        </v-avatar>
                                                    </a>
                                                </template>
                                            </v-hover>
                                        </div>
                                    </v-card>
                                </v-skeleton-loader>
                            </v-col>
                        </v-row>
                    </v-container>
				</v-flex>
				<v-flex md3 xs12>
					<Servicios />
				</v-flex>
			</v-layout>
		</v-container>
	</div>
</template>
<script>
  const Servicios = () => import('@/components/Servicios.vue')
	export default {
		components: {
			Servicios
		},
        data() {
            return {
                loading:false,
                items: [
                        {
                        color: '#1F7087',
                        title: 'Sede Juliaca',
                        subtitle: 'PUNO - SAN ROMAN - JULIACA',
                        direccion: 'Plaza zarumillas',
                        location:"https://www.google.com.pe/maps/place/Poder+Judicial+Juliaca/@-15.4959532,-70.1276728,19.41z/data=!4m13!1m7!3m6!1s0x9167f3e5361625b9:0x2a1629113760cbfc!2sJuliaca!3b1!8m2!3d-15.4996879!4d-70.129653!3m4!1s0x9167f3ee9d5518a9:0xa8b96cc0b89b5c21!8m2!3d-15.4956035!4d-70.1276131",
                        },
                        {
                        color: '#1F7087',
                        title: 'Sede Huancané',
                        subtitle: 'PUNO - HUANCANE - HUANCANE',
                        direccion: 'Jr. Santa Bárbara N° 115',
                        location: "https://www.google.com.pe/maps/dir//C.p+Huancane+Barrio+Santa+Barbara,+Huancan%C3%A9+21316/@-15.2044064,-69.7626931,197m/data=!3m1!1e3!4m8!4m7!1m0!1m5!1m1!1s0x9167a1ff112950c7:0xef93e2b3683397d2!2m2!1d-69.7624809!2d-15.2044675"
                        },
                        {
                        color: '#1F7087',
                        title: 'Sede Lampa',
                        subtitle: 'PUNO - LAMPA - LAMPA',
                        direccion: 'Jr. Alfonso Ugarte Esq. Jr. Lima',
                        location:"https://www.google.com.pe/maps/place/Poder+Judicial+Lampa/@-15.3639907,-70.3684463,241m/data=!3m2!1e3!4b1!4m5!3m4!1s0x9167e37d23c4f7c5:0xbe094cf6ca9fb14!8m2!3d-15.3639907!4d-70.3678954"
                        },
                        {
                        color: '#1F7087',
                        title: 'Sede Ayaviri',
                        subtitle: 'PUNO - MELGAR - AYAVIRI',
                        direccion: 'Jr. Tacna N° 205',
                        location:"https://www.google.com.pe/maps/dir//-14.8836145,-70.5899405/@-14.8838929,-70.5902041,242m/data=!3m1!1e3!4m2!4m1!3e0"
                        },
                        {
                        color: '#1F7087',
                        title: 'Sede Azángaro',
                        subtitle: 'PUNO - AZANGARO - AZANGARO',
                        direccion: 'Av. Tacna con Arica S/N',
                        location:"https://www.google.com.pe/maps/dir//Av+Tacna+586-600,+Az%C3%A1ngaro+21157/@-14.9108494,-70.1990318,67m/data=!3m1!1e3!4m8!4m7!1m0!1m5!1m1!1s0x9167cd217f927499:0xcb5e33caa5340495!2m2!1d-70.1991461!2d-14.9110514"
                        },
                        {
                        color: '#1F7087',
                        title: 'Sede Moho',
                        subtitle: 'PUNO - MOHO - MOHO',
                        direccion: 'Jr. Puno 440',
                        location:"https://www.google.com/maps/dir//-15.3601922,-69.5007781/@-15.3602038,-69.5009945,19z/data=!4m2!4m1!3e0"
                        },
                        {
                        color: '#1F7087',
                        title: 'Sede Macusani',
                        subtitle: 'PUNO - CARABAYA - MACUSANI',
                        direccion: 'Jr. Arequipa esq. Jr. Ayaviri',
                        location:"https://www.google.com.pe/maps/dir//-14.0716216,-70.4303252/@-14.0716307,-70.4308199,242m/data=!3m1!1e3!4m2!4m1!3e0"
                        },
                        {
                        color: '#1F7087',
                        title: 'Sede Putina',
                        subtitle: 'PUNO - SAN ANTONIO DE PUTINA - PUTINA',
                        direccion: 'Jr. Vía Crucis N° 203',
                        location:"https://www.google.com.pe/maps/place/Poder+Judicial,+Juzgado+de+Putina/@-14.9156057,-69.8696641,242m/data=!3m2!1e3!4b1!4m13!1m7!3m6!1s0x9167b2647f169811:0xf053f1d633a1de59!2sSan+Antonio+de+Putina+21340!3b1!8m2!3d-14.91256!4d-69.874893!3m4!1s0x9167b39f9b14e96f:0xc96081e5bc1c3754!8m2!3d-14.9156057!4d-69.8691169"
                        },
                        {
                        color: '#1F7087',
                        title: 'Sede Sandia',
                        subtitle: 'PUNO - SANDIA - SANDIA',
                        direccion: 'Jr. Lima S/N',
                        location:"https://www.google.com/maps/dir//-14.3220009,-69.4654444/@-14.3221414,-69.4661324,18.15z/data=!4m2!4m1!3e0"
                        },
                        
                    ]
            }
        },
	}

</script>
